import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import { getHideAllPricesModeOn } from "@store/Store/Data/HideAllPricesMode/HideAllPricesModeSelector";
import activateRetailMode from "@store/Store/Data/RetailMode/Handlers/ActivateRetailMode";
import {
    getRetailModeActive,
    getRetailModeForced,
    getRetailModeOn,
} from "@store/Store/Data/RetailMode/RetailModeSelector";
import loadRetailModeSettings from "@store/Store/Data/RetailModeSettings/Handlers/LoadRetailModeSettings";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

type StoreRetailModeToggleProps = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: StoreApplicationState) => ({
    isRetailModeActive: getRetailModeActive(state),
    isRetailModeOn: getRetailModeOn(state),
    isRetailModeForced: getRetailModeForced(state),
    hideAllPrices: getHideAllPricesModeOn(state),
});

const mapDispatchToProps = {
    loadRetailModeSettings,
    activateRetailMode,
};

const StoreRetailModeToggle: React.FC<StoreRetailModeToggleProps> = ({
    isRetailModeActive,
    isRetailModeOn,
    isRetailModeForced,
    hideAllPrices,
    loadRetailModeSettings,
    activateRetailMode,
}) => {
    useEffect(() => {
        loadRetailModeSettings();
    }, []);

    if (!isRetailModeActive) {
        return null;
    }

    const onActivateRetailHandler: CheckboxProps["onChange"] = (_, value) => {
        activateRetailMode(value);
    };

    return (
        <Checkbox
            onChange={onActivateRetailHandler}
            checked={isRetailModeOn}
            disabled={isRetailModeForced || hideAllPrices}
        >
            {translate("Retail Mode")}
        </Checkbox>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreRetailModeToggle);